import React, { useState, useRef } from 'react'
import { styled } from 'styled-components'


const PER_PAGE = 1

const CoursesSection = ({courses = []}) => {
  const [page, setPage] = useState(0)
  const pages = Math.ceil(courses.length / PER_PAGE)
  const trackRef = useRef(null)

  const goTo = (p) => setPage(p)

  const offset = page * PER_PAGE

  return (
    <Section>
      <SectionSub>
        This workshop will feature seven courses across three days. Each attendee is allowed to participate in only three (3).
        This includes the two (2) mandatory courses and one (1) optional specialization track.
      </SectionSub>

      <SliderWrap>
        <CardsTrack ref={trackRef} $offset={offset}>
          {courses.map((course) => (
            <Card key={course.id}>
              <CardImage style={{ background : '#ffffff'}}>
                <img src={course.bg} />
              </CardImage>
              <CardBody>
                <CardTop>
                  <CardTitle>{course.title}</CardTitle>
                  {course.mandatory && <MandatoryBadge>Mandatory</MandatoryBadge>}
                </CardTop>
                <CardDesc>{course.desc}</CardDesc>
               {/* <CardFooter>
                  <CardTag $optional={!course.mandatory}>{course.tag}</CardTag>
                </CardFooter> */}
              </CardBody>
            </Card>
          ))}
        </CardsTrack>
      </SliderWrap>

      <NavRow>
        <NavBtn onClick={() => goTo(page - 1)} disabled={page === 0}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2.5"
            strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </NavBtn>

        <Dots>
          {Array.from({ length: pages }).map((_, i) => (
            <Dot key={i} $active={i === page} onClick={() => goTo(i)} />
          ))}
        </Dots>

        <NavBtn onClick={() => goTo(page + 1)} disabled={page >= pages - 1}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2.5"
            strokeLinecap="round" strokeLinejoin="round">
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </NavBtn>
      </NavRow>
    </Section>
  )
}

const Section = styled.section`
  padding: 2rem 2.5rem;
  @media (min-width: 800px) { padding: 0rem 1rem; }
`


const SectionSub = styled.p`
  font-size: 14px; color: #666;
  line-height: 1.65; margin-bottom: 2.5rem;
  
`

const SliderWrap = styled.div`
  overflow: hidden;
  
`

const CardsTrack = styled.div`
  display: flex;
  gap: 20px;
  transform: translateX(calc(-${p => p.$offset} * (100% / 3 + 5px)));
  transition: transform 0.45s cubic-bezier(.4, 0, .2, 1);

  @media (max-width: 850px) {
    transform: translateX(calc(-${p => p.$offset} * (20vw + 20px)));
  }

  @media (max-width: 450px) {
    transform: translateX(calc(-${p => p.$offset} * (100% + 20px)));
  }
`

const Card = styled.div`
  flex: 0 0 calc(33.33% - 14px);
  min-width: 0;
  background: linear-gradient(135deg, #0c4e80ff 0%, #082D4A 100%);
  border-radius: 14px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover { transform: translateY(-4px); box-shadow: 0 12px 32px rgba(0,0,0,0.10); }

  @media (max-width: 850px) {
    flex: 0 0 calc(33.33% - 14px);
  }

  @media (max-width: 450px) {
    flex: 0 0 100%;
  }
`

const CardImage = styled.div`
  width: 100%;
  height: 180px;
  overflow: hidden;

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
`

const CardBody = styled.div`
    padding: 12px 20px 0px;
    border-top: 0.5px solid rgba(0,0,0,0.06);

    display: flex;
    flex-direction: column;
    gap: 10px;

    height: 10%;
`

const CardTop = styled.div`
  display: flex; align-items: flex-start;
  justify-content: space-between; gap: 8px;
`

const CardTitle = styled.h3`
  font-size: 1.3rem;
  font-weight: 600;
  color: #CA9D3B;
  line-height: 1.3;
`

const MandatoryBadge = styled.span`
  flex-shrink: 0;
  font-size: 10px; font-weight: 600;
  letter-spacing: 0.8px; text-transform: uppercase;
  padding: 3px 9px; border-radius: 999px;
  background: #FAEEDA; color: #633806;
  border: 0.5px solid #FAC775;
  white-space: nowrap; margin-top: 2px;
`

const CardDesc = styled.p`
  font-size: 13px; color: #ffffff; line-height: 1.6;
`

const CardFooter = styled.div`
    margin-top: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 0.5px solid rgba(255,255,255,0.08);
    padding-top: 12px;
`

const CardTag = styled.span`
  bottom : 0px;
  font-size: 11px; font-weight: 500;
  padding: 3px 10px; border-radius: 999px;
  background: ${p => p.$optional ? '#f3f4f6' : '#E6F1FB'};
  color: ${p => p.$optional ? '#6b7280' : '#0C447C'};
  border: 0.5px solid ${p => p.$optional ? '#e5e7eb' : '#B5D4F4'};
`

const CardArrow = styled.div`
  width: 30px; height: 30px; border-radius: 50%;
  border: 0.5px solid rgba(0,0,0,0.12);
  display: flex; align-items: center; justify-content: center;
  color: #0c4e80; transition: background 0.2s, border-color 0.2s;

  ${Card}:hover & { background: #0c4e80; border-color: #0c4e80; color: #fff; }
`

const NavRow = styled.div`
  display: flex; align-items: center;
  justify-content: center; gap: 16px;
  margin-top: 2rem;
`

const NavBtn = styled.button`
  width: 34px; height: 34px; border-radius: 50%;
  border: 0.5px solid rgba(0,0,0,0.15);
  background: #fff; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  color: #1a1a1a; transition: all 0.2s;

  &:hover:not(:disabled) { background: #0c4e80; color: #fff; border-color: #0c4e80; }
  &:disabled { opacity: 0.3; cursor: default; }
`

const Dots = styled.div`
  display: flex; gap: 6px; align-items: center;
`

const Dot = styled.div`
  height: 8px; border-radius: 4px; cursor: pointer;
  background: ${p => p.$active ? '#0c4e80' : 'rgba(0,0,0,0.15)'};
  width: ${p => p.$active ? '22px' : '8px'};
  transition: all 0.3s ease;
`

export default CoursesSection